import html2canvas from 'html2canvas';

/**
 * Rasterizes a DOM element to a <canvas> via html2canvas — the shared primitive behind image-based
 * slides (createImageSlide) and any feature that needs a PNG of live DOM (e.g. Report's diagram
 * download). The default onclone strips dark mode and does guarded, best-effort cosmetic cleanup for
 * card/tree wrappers (no-ops when those elements are absent); pass `onclone` to override entirely.
 *
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @param {Function} [options.onclone] custom html2canvas onclone (replaces the default cleanup)
 * @returns {Promise<HTMLCanvasElement>}
 */
export const createCanvasFromElement = async (element, { onclone } = {}) =>
  html2canvas(element, {
    logging: false,
    onclone:
      onclone ||
      ((document) => {
        document.body.classList.remove('dark');
        const input = document.querySelector('.tree-wrapper');
        const nodes = document.querySelectorAll('.node-wrapper');
        nodes.forEach((node) => {
          node.style.boxShadow = 'none';
        });
        // guard: non-tree DOM has no .tree-wrapper — don't throw and abort the capture
        if (input) input.style.padding = '15px';
      }),
    scrollX: -window.scrollX,
    scrollY: -window.scrollY,
  });
